import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';  // Import RouterModule from @angular/router
import { LocationStrategy, HashLocationStrategy } from '@angular/common';  // Correct import here
import { AppComponent } from './app.component';
import { ButtonNavModule } from './shared/components/button-nav/button-nav.component';
import { SurveyService } from './service/Survey/survey.service';
import { ConfigService } from './service/config.service';
import { HeaderModule } from './shared/components/header/header.component';
import { ConfirmationComponent } from './pages/confirmation/confirmation.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button'; // For buttons, if used
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AppComponent, ConfirmationComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    CommonModule,
    ButtonNavModule,
    MatTooltipModule,
    MatButtonModule,
    BrowserAnimationsModule,
    HeaderModule
  ],
  providers: [
    SurveyService,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [ConfigService],
      useFactory: (configService: ConfigService) => {
        return () => {
          return configService.loadAppConfig();
        };
      },
    },
    // Correct LocationStrategy configuration:
    { provide: LocationStrategy, useClass: HashLocationStrategy }  // <-- This line is correct
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
